import React from "react";
import styles from "./NotFound.module.css";

const NotFound = () => {
  return (
    <main className={styles.notFoundPage}>
      <div className={styles.container}>
        <h1>404</h1>
        <p>Page Not Found</p>
      </div>
    </main>
  );
};

export default NotFound;
